import { render, staticRenderFns } from "./complaints-technical-error.pug?vue&type=template&id=c79bcbc6&lang=pug&external"
import script from "./complaints-technical-error.js?vue&type=script&lang=js&external"
export * from "./complaints-technical-error.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports